// src/pages/Auth/ResetPassword/useSupportTicket.js
import { useState } from 'react';
import { createSupportTicket , supportTickets } from '../../../services/supportTicket';
import validateByType from '../../../hooks/useFormValidation';

const useSupportTicket = ({ onSuccess } = {}) => {
  const [form, setForm] = useState({
    subject: '',
    description: '',
  });

  const [file, setFile] = useState(null);
  const [supportTicketState, setSupportTicketState] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  

  const getSupportTickets = async () =>{
    setLoading(true);
    try {
      let response = await supportTickets();
      if (response && response.success && response.data) {
        return response.data
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      setErrors((prev) => ({
        ...prev,
        file: 'Please upload a valid file.',
      }));
    } else {
      setFile(selectedFile);
      setErrors((prev) => {
        const { file, ...rest } = prev;
        return rest;
      });
    }
  };

  const resetForm = () => {
    setForm({ subject: '', description: '' });
    setFile(null);
    setErrors({});
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateByType('support', form);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append('support_ticket[subject]', form.subject);
    formData.append('support_ticket[description]', form.description);
    if (file) formData.append('support_ticket[file]', file);

    setLoading(true);
    try {
      await createSupportTicket(formData);
      resetForm();
      if (onSuccess) onSuccess(); //  correctly invoked now
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    const modalEl = document.getElementById('supportModal');
    const modalInstance = window.bootstrap?.Modal.getInstance(modalEl) ||
                          new window.bootstrap.Modal(modalEl);
    modalInstance.hide();
    resetForm();
  };

  return {
    form,
    onChange,
    onSubmit,
    loading,
    errors,
    file,
    handleFileChange,
    resetForm,
    handleClose,
    supportTicketState,getSupportTickets,setSupportTicketState
  };
};

export default useSupportTicket;
